import React, { useContext } from 'react';
import { OfficerAdminAppKeys, OfficerAdminContext } from '../../../../global/models/officer-admin-model';
import { SortButton } from '../../../../search/components/sort';
import { SearchProps } from '../../models/arc-epi-props';



interface OfficersListLabelsProps {
	settings: SearchProps,
	isSenior: boolean,
}

export const OfficersListLabels = (props: OfficersListLabelsProps) => {

	const app = useContext(OfficerAdminContext);

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell icon-row-title'>
				<SortButton label={app === OfficerAdminAppKeys.officer ? props.settings?.officerUsernameLabel : props.settings?.groupAdminsUsernameLabel} name='last_name' />
			</div>
			<div className='sort-table-row-cell'>
				<p className='input-label'>{app === OfficerAdminAppKeys.officer ? props.settings?.officerBusinessPhonenumber : props.settings?.groupAdminsBusinessPhonenumber}</p>
			</div>
			<div className='sort-table-row-cell'>
				<p className='input-label'>{app === OfficerAdminAppKeys.officer ? props.settings?.officerEmailAddressLabel : props.settings?.groupAdminsEmailAddressLabel}</p>
			</div>
			<div className='sort-table-row-cell'>
				<p className='input-label'>{props.settings?.groupAdminsRoleLabel}</p>
			</div>
			{
				props.isSenior &&
				<div className='sort-table-row-cell'>
					<p className='input-label'>{props.settings?.groupAdminsActionLabel}</p>
				</div>
			}

		</div>
	);

};